export default "__VITE_ASSET__CUcYbFuF__"